<template>
    <div class='page'>
        <el-form
            v-if='isSearch'
            :model='queryForm'
            ref='searchForm'
            label-width='80px'
            :inline='true'
            size='small'
            class='query-form'
            @submit.native.prevent
        >
            <el-form-item label='手机号' prop='userMobile'>
                <el-input
                    v-model='queryForm.userMobile'
                    style='width: 177px'
                    placeholder='请输入手机号'
                    clearable
                ></el-input>
            </el-form-item>
            <el-form-item>
                <el-button type='primary' icon='el-icon-search' size='small' @click='handleSearch'>查询</el-button>
                <el-button icon='el-icon-refresh' size='small' @click='handleReset'>重置</el-button>
            </el-form-item>
        </el-form>
        <div class='page-content'>
            <div class='page-tool-bar'>
                <div class='el-btn-group'>
                    <el-button type='primary' size='small' icon='el-icon-plus' @click='handleAdd'>新增</el-button>
                </div>
                <div class='icon-group'>
                    <span class='icon-box' title='搜索' @click='toggleSearch'>
                        <Icon color='#606266'>
                            <Search />
                        </Icon>
                    </span>
                    <span class='icon-box' title='刷新' @click='refreshList'>
                        <Icon color='#606266'>
                            <Refresh />
                        </Icon>
                    </span>
                </div>
            </div>
            <el-table
                max-height='100%'
                :data='tableData.list'
                row-key='id'
                border
                v-loading='tableLoading'
                :header-row-style="{height: '10px'}"
                :header-cell-style="{padding: '10px'}"
                :row-style="{height: '9px'}"
                :cell-style="{padding: '9px'}"
                size='small'
            >
                <el-table-column align='center' prop='userName' label='用户名' min-width='120' show-overflow-tooltip></el-table-column>
                <el-table-column align='center' prop='userMobile' label='手机号' min-width='130'></el-table-column>
                <el-table-column align='center' prop='status' label='状态' width='100'>
                    <template slot-scope='scope'>
                        <el-tag v-if='scope.row.status === 0' type='success' size='small'>启用</el-tag>
                        <el-tag v-else-if='scope.row.status === 1' type='info' size='small'>禁用</el-tag>
                        <el-tag v-else type='info' size='small'>--</el-tag>
                    </template>
                </el-table-column>
                <el-table-column align='center' prop='remarks' label='备注' min-width='160' show-overflow-tooltip></el-table-column>
                <el-table-column align='center' prop='createTime' label='创建时间' min-width='160'></el-table-column>
                <el-table-column align='center' label='操作' width='100' fixed='right'>
                    <template slot-scope='scope'>
                        <el-button type='text' size='small' style='color: #f56c6c;' @click='handleDelete(scope.row)'>删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class='pagination-box'>
                <el-pagination
                    @size-change='(size) => { queryForm.pageSize = size; getTableData(); }'
                    @current-change='(page) => { queryForm.pageNum = page; getTableData(); }'
                    :current-page='queryForm.pageNum'
                    :page-sizes='[10, 20, 50, 100]'
                    :page-size='queryForm.pageSize'
                    layout='total, sizes, prev, pager, next, jumper'
                    background
                    :total='tableData.total'>
                </el-pagination>
            </div>
        </div>
        <el-dialog
            :visible.sync='dialogVisible'
            title='新增开户用户'
            width='30vw'
            :before-close='handleCloseDialog'
        >
            <div class='detail-dialog-content'>
                <el-form
                    ref='accountHolderForm'
                    :model='dialogData'
                    :rules='dialogRules'
                    label-width='100px'
                    size='small'
                    style='width: 80%;'
                >
                    <el-form-item label='用户' prop='userId'>
                        <GridSelectU
                            style='width: 100%'
                            title='选择用户'
                            labelName='userName'
                            labelValue='id'
                            :value='dialogData.userId'
                            :limit='1'
                            size='small'
                            placeholder='请选择用户'
                            @getValue='(value) => { dialogData.userId = value; }'
                            :columns='USER_code'
                            :searchs='USER_search'
                            dataListUrl='/mpp/user/findList'
                            entityBeanName='mppUser'
                            queryEntityUrl='/mpp/user/get'
                        ></GridSelectU>
                    </el-form-item> 
                    <el-form-item label='状态' prop='status'>
                        <el-switch
                            v-model='dialogData.status'
                            :active-value='0'
                            :inactive-value='1'
                            active-color='#13ce66'
                            active-text='启用'
                            inactive-text='禁用'
                        ></el-switch>
                    </el-form-item>
                    <el-form-item label='备注' prop='remarks'>
                        <el-input
                            v-model='dialogData.remarks'
                            type='textarea'
                            :rows='4'
                            placeholder='请输入备注'
                        ></el-input>
                    </el-form-item>
                </el-form>
            </div>
            <div slot='footer' class='dialog-footer'>
                <el-button type='primary' :loading='saveLoading' @click='handleConfirmDialog'>确定</el-button>
                <el-button @click='handleCloseDialog'>取消</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { Refresh, Search } from '@v2icons/tabler';
import { post, get, postJson } from '@/utils/request.js';
import GridSelectU from '@/components/gridselect/index.vue';
import { USER, USER_SEARCH } from '@/utils/constant.js';

export default {
    name: 'AccountHolder',
    components: {
        Refresh,
        Search,
        GridSelectU
    },
    data() {
        return {
            isSearch: false,
            queryForm: {
                pageNum: 1,
                pageSize: 10,
                userMobile: ''
            },
            tableData: {
                list: [],
                total: 0
            },
            tableLoading: false,
            dialogVisible: false,
            saveLoading: false,
            dialogData: {
                userId: '',
                status: 0,
                remarks: ''
            },
            dialogRules: {
                userId: [{ required: true, message: '请选择用户', trigger: 'change' }]
            },
            USER_code: USER,
            USER_search: USER_SEARCH
        };
    },
    mounted() {
        this.getTableData();
    },
    methods: {
        toggleSearch() {
            this.isSearch = !this.isSearch;
        },
        getTableData() {
            this.tableLoading = true;
            get('/shop/special/account/user/findList', { ...this.queryForm }).then((res) => {
                if (res.success) {
                    if (res.page) {
                        this.tableData.list = res.page.list;
                        this.tableData.total = res.page.total;
                    } else {
                        this.tableData.list = res.list || [];
                        this.tableData.total = this.tableData.list.length;
                    }
                } else {
                    this.$message({
                        message: res.msg,
                        type: 'error',
                        duration: 2000
                    });
                }
            }).finally(() => {
                this.tableLoading = false;
            });
        },
        handleSearch() {
            this.queryForm.pageNum = 1;
            this.getTableData();
        },
        handleReset() {
            this.queryForm.userMobile = '';
            this.queryForm.pageNum = 1;
            this.getTableData();
        },
        refreshList() {
            this.queryForm.pageNum = 1;
            this.getTableData();
        },
        getDefaultDialogData() {
            return {
                userId: '',
                status: 0,
                remarks: ''
            };
        },
        resetDialogData() {
            this.dialogData = this.getDefaultDialogData();
            this.$nextTick(() => {
                if (this.$refs.accountHolderForm) {
                    this.$refs.accountHolderForm.resetFields();
                    this.$refs.accountHolderForm.clearValidate();
                }
            });
        },
        handleCloseDialog() {
            this.dialogVisible = false;
            this.resetDialogData();
        },
        handleAdd() {
            this.dialogData = this.getDefaultDialogData();
            this.dialogVisible = true;
            this.$nextTick(() => {
                if (this.$refs.accountHolderForm) {
                    this.$refs.accountHolderForm.clearValidate();
                }
            });
        },
        handleConfirmDialog() {
            this.$refs.accountHolderForm.validate((valid) => {
                if (!valid) {
                    return;
                }
                this.saveLoading = true;
                postJson('/shop/special/account/user/save', { ...this.dialogData }).then((res) => {
                    if (res.success) {
                        this.$message({
                            message: res.msg || '保存成功',
                            type: 'success',
                            duration: 2000
                        });
                        this.handleCloseDialog();
                        this.getTableData();
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'error',
                            duration: 2000
                        });
                    }
                }).finally(() => {
                    this.saveLoading = false;
                });
            });
        },
        handleDelete(row) {
            this.$confirm('确定删除该开户用户吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                post('/shop/special/account/user/delete', { id: row.id }).then((res) => {
                    if (res.success) {
                        this.$message({
                            message: res.msg || '删除成功',
                            type: 'success',
                            duration: 2000
                        });
                        this.getTableData();
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'error',
                            duration: 2000
                        });
                    }
                });
            }).catch(() => {});
        }
    }
};
</script>

<style scoped></style>
